import {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {Badge} from 'reactstrap'

import BlueCheck from '../../../../../components/BlueCheck/BlueCheck.jsx'
import Date from '../../../../../../shared/components/Moment/Date.jsx'
import Datetime from '../../../../../../shared/components/Moment/Datetime.jsx'
import Skills from '../../../../../components/Skills/Skills.jsx'
import StateLabel from '../../../../../components/Offer/StateLabel/StateLabel.jsx'

import Calendar from 'react-feather/dist/icons/calendar.js'
import MapPin from 'react-feather/dist/icons/map-pin.js'
import Coins from '../../../../../media/svg/coins.svg'

import './OfferSearchCard.scss'

const universes = ['Aucun', 'Achats & Supply', 'Finance', 'Ressources Humaines', 'Ingénierie']

export default class OfferSearchCard extends PureComponent {
  static propTypes = {
    isAdmin: PropTypes.bool,
    offer: PropTypes.object.isRequired,
    selected: PropTypes.bool,
    onOpen: PropTypes.func,
  }

  static defaultProps = {
    isAdmin: false,
    selected: false,
    onOpen: () => {},
  }

  render() {
    const {isAdmin, offer, selected, onOpen} = this.props
    const smsSent = offer?.sms_ticket?.nb_sendings ?? 0
    const showNbAnswers = isAdmin && offer.nbOfferAnswer > 0
    const showSmsSent = isAdmin && smsSent > 0
    const location = isAdmin ? (offer?.city?.[0]?.label ?? '') : (offer?.city?.[0]?.departement ?? '')

    return (
      <div
        className={`offer-search-card${selected ? ' offer-search-card--selected' : ''}`}
        onClick={onOpen}
      >
        {(showNbAnswers || showSmsSent) && (
          <div className="offer-search-card__header">
            {showNbAnswers && <Badge color="light">{offer.nbOfferAnswer} candidature(s)</Badge>}
            {showSmsSent && <Badge color="info">{smsSent} sms</Badge>}
          </div>
        )}

        <div className="offer-search-card__body">
            <div className="offer-search-card__counters">
              {offer?.universe ? (
                <Badge color="secondary">{universes[offer.universe]}</Badge>
              ) : null}

              <StateLabel filled={offer.filled} locked={offer.locked} published={offer.published} />

              {offer.hasAnswer && !isAdmin ? (
                <BlueCheck hasTooltip tooltipOverlay="J'ai postulé" small={true} />
              ) : null}
            </div>

            <h3 className="offer-search-card__title">
              {offer?.title ?? ''}
            </h3>

            {isAdmin && (
              <p className="offer-search-card__client">
                Client : {offer?.client_name ?? 'N/A'}
              </p>
            )}

            <ul className="offer-search-card__more">
                <li>
                  <Coins />
                  {offer?.tjm_text ?? 'Non précisé'}
                </li>

                <li>
                  <Calendar size={18} />
                  <Date date={offer.start_date} />
                </li>

                {location && (
                  <li>
                    <MapPin size={18} />
                    {location}
                  </li>
                )}
            </ul>

            {offer.keywords?.length ? (
              <>
                <p className="offer-search-card__subtitle">
                  Compétences
                </p>

                <Skills
                  key={offer.id}
                  length={offer?.keywords_length ?? 3}
                  className="offer-search-card__skills"
                  list={offer.keywords}
                  forceNoLink={true}
                />
              </>
            ) : null}
          </div>

          {isAdmin && offer?.publication_date && (
              <div className="offer-search-card__footer">
                  Publiée le <Datetime date={offer.publication_date} />
              </div>
          )}
      </div>
    )
  }
}
